import React,  { useEffect, useState } from "react"

//model
import { GetStartedModel } from "./GetStarted.model";

//components
import { BasicButton, IconLibrary, ThriveIcon, MobileAppPreview } from "thrive-components";
import { getStartedIllustration } from "../../static";
import { getStartedVideo } from '../../static';

//hooks
import useNavigatorSetup from "../../utils/hooks/useNavigatorSetup";
import useScrollToTop from "../../utils/hooks/useScrollToTop";

//interfaces
import { IContentTile } from "thrive-components/interfaces/content/content";

//styles
import './get-started.scss';



const GetStarted = ({}) => {
    const [GSM] = useState(() => new GetStartedModel());
    
    useScrollToTop();
    useNavigatorSetup();
    useEffect(() => {
        GSM.getStarted();
    }, []);

    return (
        <div className="get-started-page page-container">
            <div className="get-started-container">
                <img 
                    className='get-started-illustration' 
                    src={getStartedIllustration} 
                    alt='' 
                />
                        
                <h1 className="get-started-heading">
                    {GSM.title}
                </h1>

                <h2 className="get-started-sub-heading">
                    {GSM.subtitle}
                </h2>

                <p className="get-started-information">
                    {GSM.information}
                </p>

                <BasicButton 
                    className="get-started-button"
                    content={
                        <>
                        {GSM.button}
                        <ThriveIcon 
                            iconName={IconLibrary.ARROW_LEFT}
                            className="right-arrow"
                            color="var(--thriveWhite)"
                            sizeInPx="14"
                        />
                        </>
                    } 
                    ariaLabel={GSM.button}     
                    onButtonClick={GSM.onButtonClick}
                />
            </div>

            <div className="video-mobile-app">
                <video
                    src={getStartedVideo}
                    autoPlay
                    loop
                    muted
                    playsInline
                    aria-hidden="true"
                    tabIndex={-1}
                />
            </div>
        </div>
    );
}

export default GetStarted